import { AddLink, DeleteButton, EditLink } from "app/components/buttons";
import { Column } from "app/components/column";
import { Container } from "app/components/container";
import { DFlexResponsive } from "app/components/d-flex-responsive";
import { Row } from "app/components/row";
import { Table } from "app/components/table";
import { useEmpresa } from "app/contexts";

export function CorreosElectronicosTable() {
  const { empresa, deleteCorreoElectronico } = useEmpresa();

  return (
    <Container>
      <Row>
        <Column>
          <DFlexResponsive justifyContent="between">
            <h5>
              <strong>Direcciones de correo electrónico (requerido)</strong>
            </h5>

            <AddLink
              to="correos-electronicos/add"
              title="Agregar dirección de correo electrónico"
            />
          </DFlexResponsive>
        </Column>

        <Column>
          {!!empresa.correos_electronicos.length ? (
            <Table
              responsive
              titles={[
                "#",
                "Tipo",
                "Dirección de correo electrónico",
                "Opciones",
              ]}
            >
              {empresa.correos_electronicos.map((correo, i) => (
                <tr key={i}>
                  <td className="text-center">{i + 1}</td>

                  <td className="text-center">
                    {correo.correo_electronico_principal
                      ? "Principal"
                      : "Secundaria"}
                  </td>

                  <td>
                    <a href={`mailto:${correo.correo_electronico_direccion}`}>
                      {correo.correo_electronico_direccion}
                    </a>
                  </td>

                  <td>
                    <DFlexResponsive>
                      <EditLink to={`correos-electronicos/${i}/edit`} />

                      <DeleteButton
                        size="sm"
                        onClick={() => deleteCorreoElectronico(i)}
                      />
                    </DFlexResponsive>
                  </td>
                </tr>
              ))}
            </Table>
          ) : (
            <p className="lead text-center">
              Por favor, agregue al menos una dirección de correo electrónico
            </p>
          )}
        </Column>
      </Row>
    </Container>
  );
}
